import format from 'date-fns/format'; // tslint:disable-line
import React from 'react';
import Helmet from 'react-helmet';
import config from '../config';

interface Props {
  pageData: Partial<{
    description: string;
    title: string;
    datePublished: Date;
    url: string;
  }>;
  isBlogPost: boolean;
}

const getSchema = ({ isBlogPost, url, title, desc, datePublished }: any) => {
  let schema: any[] = [
    {
      '@context': 'http://schema.org',
      '@type': 'WebSite',
      url: config.url,
      name: title,
      alternateName: config.title,
    },
  ];

  if (isBlogPost) {
    schema = [
      ...schema,
      {
        '@context': 'http://schema.org',
        '@type': 'BlogPosting',
        url: `${config.url}${url}`,
        name: title,
        headline: title,
        description: desc,
        author: {
          '@type': 'Person',
          name: 'Cameron Woodmansee',
        },
        publisher: {
          '@type': 'Organization',
          url: config.url,
          name: 'Cameron Woodmansee',
        },
        mainEntityOfPage: {
          '@type': 'WebSite',
          '@id': config.url,
        },
        datePublished,
      },
    ];
  }

  return schema;
};

const SEO: React.SFC<Props> = ({ pageData, isBlogPost }) => {
  const desc = pageData.description || config.description;
  const title = pageData.title || config.title;
  const url = pageData.url || config.url;
  const datePublished = isBlogPost
    ? format(pageData.datePublished, 'YYYY-MM-DDTHH:mm:ssZ')
    : false;

  const schemaOrg = getSchema({
    isBlogPost,
    url,
    title,
    desc,
    datePublished,
  });

  return (
    <Helmet>
      {/* General tags */}
      <meta name="description" content={desc} />
      <title>{title}</title>

      {/* Schema.org tags */}
      <script type="application/ld+json">{JSON.stringify(schemaOrg)}</script>
    </Helmet>
  );
};

export default SEO;



// WEBPACK FOOTER //
// ./src/components/seo.tsx